import { InfoBox } from '@/components/sv/info-box'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import * as Styled from '@/routes/database/tabs/overview/sections/details/styles'

export const DatabaseDetailsSectionFallback = () => (
  <Card>
    <CardHeader>
      <H3>Details</H3>
    </CardHeader>
    <CardContent className="space-y-4">
      <Styled.DetailsGrid>
        <InfoBox label="Status" value={<Skeleton className="h-5.5 w-20" />} />
        <InfoBox label="Version" value={<Skeleton className="h-5.5 w-28" />} />
        <InfoBox label="Location" value={<Skeleton className="h-5.5 w-55" />} />
        <InfoBox
          label="Creation date"
          value={<Skeleton className="h-5.5 w-45" />}
        />
        <InfoBox label="ID" value={<Skeleton className="h-6 w-68" />} />
        <InfoBox label="Storage" value={<Skeleton className="h-5.5 w-50" />} />
        <InfoBox label="Compute" value={<Skeleton className="h-5.5 w-45" />} />
      </Styled.DetailsGrid>
    </CardContent>
  </Card>
)
